import InvisibleEntityReferenceComponent from '../components/InvisibleEntityReferenceComponent';
import { ComponentIds } from '@inter-ikea-core/core';
/**
 * Find the article that references the provided article id in its BRYGGA meta data.
 * @param id Id that the related article references in its meta data.
 * @param products Market products.
 * @param productTypes Valid types to check.
 * @returns Id of the article that references the provided article id or undefined.
 */
export const getRelatedArticle = (id, products, productTypes) => {
    const relatedArticleId = products.find(p => productTypes.includes(p.type) && p.meta?.relatedArticle === id)?.coreProductId;
    return relatedArticleId;
};
/**
 * Add an invisible entity to the scene with valid shopping cart data for the provided entity.
 * The visible and invisible entity each hold a reference to the other via InvisibleEntityReferenceComponent.
 * @param entity Visible entity added to scene.
 * @param products Market products.
 * @param productTypes Valid types to check.
 * @param coreApi CoreApi.
 */
export const addInvisibleEntity = (entity, products, productTypes, coreApi) => {
    if (!entity.hasComponent(InvisibleEntityReferenceComponent.id)) {
        const productRef = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)
            ?.productRef;
        if (!productRef)
            throw new Error('Entity does not have a productRef');
        const relatedArticleId = getRelatedArticle(productRef, products, productTypes);
        if (!relatedArticleId) {
            // If an adjustable product does not exists in a certain market, it's still possible
            // to auto-adapt to that variant. If there is no relatedArticleId, we dispose the new entity.
            // This is a workaround until we decide how to handle adjustable sections in markets that don't support them.
            entity.dispose();
        }
        else {
            const invisibleEntity = coreApi.getServices().productManager.createEntity(relatedArticleId);
            if (!invisibleEntity)
                throw new Error(`Could not create entity based on id: ${relatedArticleId}`);
            invisibleEntity.addComponent(new InvisibleEntityReferenceComponent(entity.id));
            coreApi.entities.placementService.forcePlaceEntity(invisibleEntity);
            entity.addComponent(new InvisibleEntityReferenceComponent(invisibleEntity.id));
        }
    }
};
/**
 * Removes the invisible entity referenced by the provided entity.
 * @param entity Visible entity removed from scene.
 * @param coreApi CoreApi.
 */
export const removeInvisibleEntity = (entity, coreApi) => {
    if (entity.hasComponent(InvisibleEntityReferenceComponent.id)) {
        const referencedEntityId = entity.getComponent(InvisibleEntityReferenceComponent.id)?.referencedEntityId;
        if (!referencedEntityId)
            throw new Error(`Could not find referenced entity with id: ${referencedEntityId}`);
        const invisibleEntity = coreApi.entities.find(referencedEntityId);
        invisibleEntity?.dispose();
        entity.removeComponent(InvisibleEntityReferenceComponent.id);
    }
};
//# sourceMappingURL=addInvisibleEntity.js.map